import { Maybe } from 'maybeasy';
import * as React from 'react';
import { ActiveProgramModule, ProgramSegment } from '../../../ProgramStore/Types';
import OutlineSegment from '../OutlineSegment';
import * as style from '../style.module.css';

interface Props {
  programModule: ActiveProgramModule;
  currentSegmentId: Maybe<number>;
  viewedSegmentReady: boolean;
  onNavigate: (segment: ProgramSegment) => void;
  latestAvailableSegmentId: Maybe<number>;
}

const OutlineSegments: React.FC<Props> = ({
  programModule,
  currentSegmentId,
  viewedSegmentReady,
  onNavigate,
  latestAvailableSegmentId,
}) => {
  return (
    <li className={style.segments} data-test-program-segments={programModule.id}>
      <ol>
        {programModule.segments.map((segment) => (
          <OutlineSegment
            key={segment.id}
            segment={segment}
            currentSegmentId={currentSegmentId}
            viewedSegmentReady={viewedSegmentReady}
            onNavigate={onNavigate}
            latestAvailableSegmentId={latestAvailableSegmentId}
          />
        ))}
      </ol>
    </li>
  );
};
export default OutlineSegments;
